module.exports = __webpack_public_path__ + "img/SA.b6a24dac.png";